var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "destination-selector"
  }, [_vm.selectedDestination === 'redirect_url' ? _c('div', {
    staticClass: "destination-selector__redirect-field"
  }, [_c('div', {
    staticClass: "destination-selector__field-wrapper",
    class: {
      'destination-selector__field-wrapper--error': _vm.isRedirectUrlInvalid
    }
  }, [_c('div', {
    staticClass: "destination-selector__content"
  }, [_c('div', {
    staticClass: "mr-3",
    class: ['destination-icon', 'destination-icon--special'],
    staticStyle: {
      "background-color": "#F2F5FF",
      "width": "30px",
      "height": "30px",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
      "border-radius": "8px",
      "padding": "7px",
      "box-sizing": "border-box"
    },
    on: {
      "click": _vm.openMenu
    }
  }, [_c('ExternalLinkIcon', {
    tag: "component",
    attrs: {
      "width": "16",
      "height": "16"
    }
  })], 1), _c('span', {
    staticClass: "mr-2 ml-3",
    on: {
      "click": _vm.openMenu
    }
  }, [_vm._v("Redirect URL:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.redirectUrl,
      expression: "redirectUrl"
    }],
    ref: "urlInput",
    staticClass: "destination-selector__url-input",
    class: {
      'destination-selector__url-input--error': _vm.isRedirectUrlInvalid
    },
    attrs: {
      "placeholder": "https://example.com"
    },
    domProps: {
      "value": _vm.redirectUrl
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.redirectUrl = $event.target.value;
      }, _vm.validateUrl],
      "click": function ($event) {
        $event.stopPropagation();
      },
      "focus": _vm.handleUrlFocus,
      "mousedown": function ($event) {
        $event.stopPropagation();
      },
      "blur": _vm.handleUrlBlur
    }
  })]), _c('div', {
    staticClass: "destination-selector__dropdown-arrow",
    on: {
      "click": _vm.openMenu
    }
  }, [_c('v-icon', [_vm._v("mdi-chevron-down")])], 1)]), _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-bottom": 2,
      "max-height": 300,
      "offset-y": "",
      "content-class": "conditional-logic-editor__target-items"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('div', _vm._g(_vm._b({
          ref: "menuActivator",
          staticStyle: {
            "position": "absolute",
            "top": "0",
            "left": "0",
            "width": "100%",
            "height": "100%",
            "opacity": "0",
            "pointer-events": "none"
          }
        }, 'div', attrs, false), on))];
      }
    }], null, false, 3814755820),
    model: {
      value: _vm.menuOpen,
      callback: function ($$v) {
        _vm.menuOpen = $$v;
      },
      expression: "menuOpen"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.allDestinationOptions, function (item) {
    return _c('v-list-item', {
      key: item.value,
      attrs: {
        "disabled": item.disabled,
        "dense": ""
      },
      on: {
        "click": function ($event) {
          return _vm.selectDestination(item);
        }
      }
    }, [item.type === 'special' ? _c('v-list-item-icon', [_c('div', {
      class: ['destination-icon', 'destination-icon--special'],
      staticStyle: {
        "background-color": "#F2F5FF",
        "width": "30px",
        "height": "30px",
        "display": "flex",
        "align-items": "center",
        "justify-content": "center",
        "border-radius": "8px",
        "padding": "7px",
        "box-sizing": "border-box",
        "margin-right": "12px"
      }
    }, [item.isEmoji ? _c('span', {
      staticClass: "destination-icon__emoji"
    }, [_vm._v(_vm._s(item.icon))]) : _c(item.icon, {
      tag: "component",
      attrs: {
        "width": "16",
        "height": "16"
      }
    })], 1)]) : _c('v-list-item-icon', [_c(item.icon, {
      tag: "component",
      attrs: {
        "width": "30",
        "height": "30"
      }
    })], 1), _c('v-list-item-content', {
      style: ("max-width: " + (item.disabled ? item.disabledLabel === 'Conditioned' ? '460px' : '500px' : '533px') + "; overflow: hidden;")
    }, [item.type !== 'special' ? _c('v-tooltip', {
      attrs: {
        "right": "",
        "disabled": !_vm.shouldShowTooltip(item)
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (_ref2) {
          var on = _ref2.on,
            attrs = _ref2.attrs;
          return [_c('v-list-item-title', _vm._g(_vm._b({
            staticClass: "destination-selector__question-title",
            staticStyle: {
              "display": "flex",
              "align-items": "center",
              "overflow": "hidden"
            }
          }, 'v-list-item-title', attrs, false), on), [_c('span', {
            staticClass: "mr-2 grey_700--text destination-selector__question-location",
            staticStyle: {
              "flex-shrink": "0"
            }
          }, [_vm._v(_vm._s(item.formattedLocation) + ":")]), _c('span', {
            staticClass: "destination-selector__question-text",
            style: ("overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: " + (item.disabled ? item.disabledLabel === 'Hidden' ? '330px' : '340px' : '433px') + ";")
          }, [_vm._v(_vm._s(item.title))])])];
        }
      }], null, true)
    }, [_c('span', {
      staticClass: "tooltip-text"
    }, [_vm._v(_vm._s(item.formattedLocation) + ": " + _vm._s(item.title))])]) : _c('v-list-item-title', {
      staticClass: "destination-selector__question-title",
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "overflow": "hidden"
      }
    }, [_c('span', {
      staticClass: "destination-selector__question-text",
      style: ("overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: " + (item.disabled ? item.disabledLabel === 'Hidden' ? '330px' : '340px' : '433px') + ";")
    }, [_vm._v(_vm._s(item.label))])])], 1), item.disabled ? _c('v-list-item-action', {
      style: ("flex-shrink: 0; min-width: 70px; margin-left: " + (item.disabledLabel === 'Conditioned' ? '24px' : '16px') + ";")
    }, [_c('span', {
      staticClass: "caption text--disabled"
    }, [_vm._v(_vm._s(item.disabledLabel))])]) : _vm._e()], 1);
  }), 1)], 1)], 1) : _c('div', {
    staticClass: "destination-selector__wrapper"
  }, [_c('f-select', {
    ref: "mainSelect",
    staticClass: "destination-selector__question conditional-logic-editor__target-field",
    attrs: {
      "items": _vm.allDestinationOptions,
      "item-value": function (item) {
        return item.value;
      },
      "item-disabled": function (item) {
        return item.disabled;
      },
      "menu-props": _vm.menuProps,
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "placeholder": _vm.dynamicPlaceholder
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('div', {
          staticStyle: {
            "display": "flex",
            "align-items": "center",
            "width": "100%",
            "overflow": "hidden"
          }
        }, [item.type === 'special' ? _c('div', {
          class: ['destination-icon', 'destination-icon--special'],
          staticStyle: {
            "background-color": "#F2F5FF",
            "width": "30px",
            "height": "30px",
            "display": "flex",
            "align-items": "center",
            "justify-content": "center",
            "border-radius": "8px",
            "padding": "7px",
            "box-sizing": "border-box",
            "flex-shrink": "0"
          }
        }, [item.isEmoji ? _c('span', {
          staticClass: "destination-icon__emoji"
        }, [_vm._v(_vm._s(item.icon))]) : _c(item.icon, {
          tag: "component",
          attrs: {
            "width": "16",
            "height": "16"
          }
        })], 1) : _c(item.icon, {
          tag: "component",
          staticStyle: {
            "flex-shrink": "0"
          },
          attrs: {
            "width": "30",
            "height": "30"
          }
        }), item.type === 'special' ? _c('span', {
          staticStyle: {
            "margin-left": "12px",
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap",
            "flex": "1"
          }
        }, [_vm._v(_vm._s(item.label))]) : [_c('div', {
          staticStyle: {
            "margin-left": "12px",
            "overflow": "hidden",
            "flex": "1",
            "display": "flex",
            "align-items": "center"
          }
        }, [_c('span', {
          staticClass: "mr-2 grey_700--text font-weight-bold",
          staticStyle: {
            "flex-shrink": "0"
          }
        }, [_vm._v(_vm._s(_vm.optionLetter) + " " + _vm._s(_vm.option.isEmoji ? '' : '.'))]), _c('span', {
          staticClass: "grey_700--text",
          staticStyle: {
            "flex-shrink": "0"
          }
        }, [_vm._v(" " + _vm._s(item.formattedLocation) + ":")]), _c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap",
            "flex": "1"
          }
        }, [_vm._v(_vm._s(item.title))])])]], 2)];
      }
    }, {
      key: "item",
      fn: function (_ref4) {
        var on = _ref4.on,
          attrs = _ref4.attrs,
          item = _ref4.item;
        return [_c('v-list-item', _vm._g(_vm._b({
          class: {
            'v-list-item--disabled': item.disabled
          },
          attrs: {
            "disabled": item.disabled
          }
        }, 'v-list-item', attrs, false), on), [item.type !== 'special' ? _c('v-tooltip', {
          attrs: {
            "right": "",
            "disabled": !_vm.shouldShowTooltip(item)
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref5) {
              var tooltipOn = _ref5.on,
                tooltipAttrs = _ref5.attrs;
              return [_c('div', _vm._g(_vm._b({
                staticClass: "d-flex align-center w-100"
              }, 'div', Object.assign({}, attrs, tooltipAttrs), false), Object.assign({}, on, tooltipOn)), [_c('v-list-item-icon', [_c(item.icon, {
                tag: "component",
                attrs: {
                  "width": "30",
                  "height": "30"
                }
              })], 1), _c('v-list-item-content', {
                style: ("max-width: " + (item.disabled ? item.disabledLabel === 'Conditioned' ? '460px' : '500px' : '533px') + "; overflow: hidden;")
              }, [_c('v-list-item-title', {
                staticClass: "destination-selector__question-title",
                staticStyle: {
                  "display": "flex",
                  "align-items": "center",
                  "overflow": "hidden"
                }
              }, [_c('span', {
                staticClass: "mr-2 grey_700--text destination-selector__question-location",
                staticStyle: {
                  "flex-shrink": "0"
                }
              }, [_vm._v(_vm._s(item.formattedLocation) + ":")]), _c('span', {
                staticClass: "destination-selector__question-text",
                style: ("overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: " + (item.disabled ? item.disabledLabel === 'Hidden' ? '330px' : '340px' : '433px') + ";")
              }, [_vm._v(_vm._s(item.title))])])], 1), item.disabled ? _c('v-list-item-action', {
                staticStyle: {
                  "flex-shrink": "0",
                  "min-width": "70px"
                }
              }, [_c('span', {
                staticClass: "caption text--disabled"
              }, [_vm._v(_vm._s(item.disabledLabel))])]) : _vm._e()], 1)];
            }
          }], null, true)
        }, [_c('span', {
          staticClass: "tooltip-text"
        }, [_vm._v(_vm._s(item.formattedLocation) + ": " + _vm._s(item.title))])]) : [_c('v-list-item-icon', [_c('div', {
          class: ['destination-icon', 'destination-icon--special'],
          staticStyle: {
            "background-color": "#F2F5FF",
            "width": "30px",
            "height": "30px",
            "display": "flex",
            "align-items": "center",
            "justify-content": "center",
            "border-radius": "8px",
            "padding": "7px",
            "box-sizing": "border-box"
          }
        }, [item.isEmoji ? _c('span', {
          staticClass: "destination-icon__emoji"
        }, [_vm._v(_vm._s(item.icon))]) : _c(item.icon, {
          tag: "component",
          attrs: {
            "width": "16",
            "height": "16"
          }
        })], 1)]), _c('v-list-item-content', {
          style: ("max-width: " + (item.disabled ? item.disabledLabel === 'Conditioned' ? '460px' : '500px' : '533px') + "; overflow: hidden;")
        }, [_c('v-list-item-title', {
          staticClass: "destination-selector__question-title",
          staticStyle: {
            "display": "flex",
            "align-items": "center",
            "overflow": "hidden"
          }
        }, [_c('span', {
          staticClass: "destination-selector__question-text",
          style: ("overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: " + (item.disabled ? item.disabledLabel === 'Hidden' ? '330px' : '340px' : '433px') + ";")
        }, [_vm._v(_vm._s(item.label))])])], 1), item.disabled ? _c('v-list-item-action', {
          style: ("flex-shrink: 0; min-width: 70px; margin-left: " + (item.disabledLabel === 'Conditioned' ? '24px' : '16px') + ";")
        }, [_c('span', {
          staticClass: "caption text--disabled"
        }, [_vm._v(_vm._s(item.disabledLabel))])]) : _vm._e()]], 2)];
      }
    }]),
    model: {
      value: _vm.selectedDestination,
      callback: function ($$v) {
        _vm.selectedDestination = $$v;
      },
      expression: "selectedDestination"
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }